import { z } from "zod";

const envSchema = z.object({
  VITE_BE_URL: z.string().url(),
  VITE_AUTO_CONNECTOR_URL: z.string().url().default("http://localhost:8003"),
  // BE del modulo AVES_SYNC (sync-stack); in prod sync.herika.cloud
  VITE_AVES_SYNC_URL: z.string().url().default("http://localhost:8010"),
  // BE moduli herika-admin (Centro di Costo); in prod pricing/directory.app.herika.cloud
  VITE_PRICING_URL: z.string().url().default("http://localhost:8021"),
  VITE_DIRECTORY_URL: z.string().url().default("http://localhost:8020"),
  // BE del modulo Pratiche (herika_practices); in prod practices.app.herika.cloud
  VITE_PRACTICES_URL: z.string().url().default("http://localhost:8022"),
  VITE_KEYCLOAK_URL: z.string().url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  VITE_DEFAULT_NATIONALITY: z.string().length(2).default("IT"),
  VITE_DEFAULT_CURRENCY: z.string().length(3).default("EUR"),
  VITE_DEFAULT_LANGUAGE: z.string().min(2).max(5).default("it"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("[env] Invalid environment variables:", parsed.error.flatten().fieldErrors);
  throw new Error(
    "Environment validation failed. Check .env file and restart the dev server.",
  );
}

export const env = parsed.data;

export type Env = typeof env;
